import React, { useState } from 'react';
import { Tooltip } from 'antd';
import { EditOutlined } from '@ant-design/icons';

function Rate({ label, pct, raw, reached, bad }) {
  const [hover, setHover] = useState(false);
  return (
    <div className={`tl-rate${bad ? ' bad' : ''}`} onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
      {hover ? <div className="p" style={{ fontSize: 10 }}>{`${raw} of ${reached} ${label}`}</div>
             : <><div className="p">{pct}%</div><div className="k">{label}</div></>}
    </div>
  );
}

const dayWord = (n) => `${n} day${n === 1 ? '' : 's'}`;

export default function TouchpointNode({ card, metrics, showMetrics = true, branches = false, onEdit = () => {} }) {
  const { touchpoint: tp, isEntry, waitDays } = card;
  const m = metrics;
  return (
    <div className="tl-tp">
      <div className="tl-tp-body">
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <h4>
            {branches && (
              <Tooltip title="This question's answer triggers a sub-journey">
                <span className="tl-branch-glyph" aria-label="triggers a sub-journey">⑂</span>
              </Tooltip>
            )}
            {tp.name}
          </h4>
          <Tooltip title="Edit (opens placeholder)"><EditOutlined aria-label="edit touchpoint" className="tl-tp-edit" onClick={() => onEdit(tp)} /></Tooltip>
        </div>
        <p className="tl-wait">⏱ {waitDays > 0 ? `${dayWord(waitDays)} ${isEntry ? 'after trigger' : 'later'}` : 'Sent immediately'}</p>
        <p className="tl-msg">{tp.message}</p>
        {showMetrics && (
          <>
            <div className="tl-counts">
              <div className="tl-cbox reached"><div className="n">{m.reached}</div><div className="k">✓ reached</div></div>
              <div className="tl-cbox pending"><div className="n">{m.pending}</div><div className="k">⏳ pending</div></div>
            </div>
            <div className="tl-rates">
              <Rate label="clicked" pct={m.clickedPct} raw={m.clickedRaw} reached={m.reached} />
              <Rate label="replied" pct={m.repliedPct} raw={m.repliedRaw} reached={m.reached} />
              <Rate label="opt-out" pct={m.optOutPct} raw={m.optOutRaw} reached={m.reached} bad />
            </div>
          </>
        )}
      </div>
    </div>
  );
}
